import React from 'react';
import PropTypes from 'prop-types';

import { categories } from '../../Data/menu_category';

const propTypes = {
  principal      : PropTypes.bool.isRequired,
  handleCategory : PropTypes.func.isRequired
}

const renderItem = ( cat, principal, handleCategory ) => {

  let locale = localStorage.locale || 'es', nameCat = "";

  if ( locale === 'es' ) {
    nameCat = cat.name
  } else if ( locale === 'en-US' ) {
    nameCat = cat.nameEng;
  }


  if ( principal === cat.principal ) {
    return (
      <a
        key           = { nameCat }
        style         = {{ color: 'white' }}
        className     = "navbar-brand"
        data-category = { cat.category }
        onClick       = { handleCategory }
        >
        <i
          className     = { cat.icon }
          data-category = { cat.category }
          >
        </i> { nameCat }
      </a>
    )
  }

}

const ItemCategory = ({ principal, handleCategory }) => {
  return (
    categories().map( (cat) =>
      renderItem( cat, principal, handleCategory)
    )
  )
}

ItemCategory.propTypes = propTypes;

export default ItemCategory;



// WEBPACK FOOTER //
// ./src/components/Menu/ItemCategory.js